var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTagStairs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 10.5H1.6C1.54477 10.5 1.5 10.4552 1.5 10.4V8.70526C1.5 8.65003 1.54477 8.60526 1.6 8.60526H3.29474C3.34997 8.60526 3.39474 8.56049 3.39474 8.50526V6.33684C3.39474 6.28161 3.43951 6.23684 3.49474 6.23684H5.66316C5.71839 6.23684 5.76316 6.19207 5.76316 6.13684V3.96842C5.76316 3.91319 5.80793 3.86842 5.86316 3.86842H8.03158C8.08681 3.86842 8.13158 3.82365 8.13158 3.76842V1.6C8.13158 1.54477 8.17635 1.5 8.23158 1.5H10.4C10.4552 1.5 10.5 1.54477 10.5 1.6V10.4C10.5 10.4552 10.4552 10.5 10.4 10.5Z",
    stroke: "white",
    className: "white-stroke-svg",
    strokeOpacity: 0.8,
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagStairs);
export default __webpack_public_path__ + "static/media/tag-stairs.ebfdd43400e56be59baacbb49d7859f6.svg";
export { ForwardRef as ReactComponent };